<script setup lang="ts">
const { store } = defineProps({
  store: {
    type: Object,
    required: true,
  },
})

const isOpen = computed(() => {
  return isStoreCurrentlyOpen(store?.today)
})
</script>

<template>
  <article
    v-if="store"
    class="store-locator-tile"
    :class="{ 'store-locator-tile--open': isOpen || store?.today?.open }"
  >
    <div class="store-locator-tile__content">
      <h3 class="store-locator-tile__heading">
        <AppLink
          :to="store.PageUrl?.url"
          class="store-locator-tile__link"
        >
          {{ store.PageTitle }}
        </AppLink>
      </h3>

      <div
        v-if="store.Description"
        class="store-locator-tile__description"
        v-text="store.Description"
      />

      <div
        v-if="store?.today"
        class="store-locator-tile__open"
      >
        <span v-if="isOpen">Nu geopend tot {{ store?.today?.close_time }}</span>
        <span v-else-if="store?.today?.open">Vandaag geopend van {{ store.today.open_time }} tot {{ store.today.close_time }}</span>
        <span v-else>Nu gesloten</span>
      </div>

      <AppLink
        :to="store.PageUrl?.url"
        class="store-locator-tile__cta"
      >
        <span>Route & openingstijden</span>
      </AppLink>
    </div>
    <div class="store-locator-tile__visual">
      <picture v-if="store?.Image?.url">
        <source
          :srcset="useXcdnImage(store.Image.url, 'f=rs:fit:1280')"
          media="(min-width: 1280px)"
        >
        <source
          v-if="store?.ImageMobile?.url"
          :srcset="useXcdnImage(store.ImageMobile.url, 'f=rs:fit:640')"
        >
        <source
          v-else
          :srcset="useXcdnImage(store.Image.url, 'f=rs:fit:640')"
        >
        <img
          class="store-locator-tile__image"
          :src="useXcdnImage(store.Image.url, 'f=rs:fit:640')"
          :alt="store.Image.alternativeText || store.PageTitle"
          :height="store.Image.height"
          :width="store.Image.width"
        >
      </picture>
    </div>
  </article>
</template>

<style>
@import url("~layers/app/components/StoreLocator/Tile.css");
</style>
